// eslint-disable-next-line
import util from 'util';

import { createMuiTheme } from '@material-ui/core/styles';

/*
 * Create the theme object
 */
export default function() {
  return(createMuiTheme(
      {
    palette: {
      primary: {
        main : "#2271da",
      },
      secondary: {
        main : "#da9a22",
      },
    },
    otherColors: {
      accent1: "#dac822",
      accent2: "#b222da",
    },
    props: {
      MuiButton : {
        variant : 'contained',
        color: 'primary',
      },
      MuiInputLabel : {
        shrink: true,
      },
    },

    overrides : {
      MuiAppBar : {
        root : {
        }
      },
      MuiButton : {
        root : {
          borderRadius: 10,
        }
      },
      MuiDialog : {
        paper : {
          padding: 10,
          borderRadius: 10,
          border: '1px solid #2271da',
        }
      },
      MuiDialogTitle : {
        root : {
          padding: 4,
        }
      },
      MuiDrawer: {
        paper: {
          backgroundColor: '#2271da',
          '& .MuiListItemText-root' : {
            color: 'white',
          },
          '& .MuiListItemIcon-root' : {
            color: 'white',
          },
        },

      },
      MuiBackdrop: {
        root : {
          backgroundColor: 'transparent',
        },
      },
    },
  }
  ));
}
